module.exports = __webpack_public_path__ + "static/media/sort-up-icon.d9ccbb84.svg";